const forTheRecord = {
    path: 'forTheRecord',
    component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftWeChat/found/forTheRecord'], resolve)
}

export default forTheRecord